var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResidentialGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 432",
    transform: "translate(-573 -439)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 125",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(573 439)",
    style: {
      fill: "#eea5b1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 124",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(575 441)",
    style: {
      fill: "#de4d65"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 462",
    d: "M19.219 21.046a.722.722 0 0 0-.722.722v2.166h1.443v-2.166a.722.722 0 0 0-.721-.722zm0-18.046a9.147 9.147 0 0 0-5.431 1.8h10.863A9.147 9.147 0 0 0 19.219 3zM12 5.527h14.437v.722H12z",
    style: {
      fill: "#080808"
    },
    transform: "translate(571 442.533)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 463",
    d: "M18 30.964h3.609V28.8a1.444 1.444 0 0 1 2.887 0v2.166h3.609V14H18zm7.58-15.881h1.444v1.444H25.58zm0 2.887h1.444v1.444H25.58zm0 2.887h1.444V22.3H25.58zm0 2.887h1.444v1.444H25.58zm0 2.887h1.444v3.248H25.58zm-3.248-11.55h1.444v1.444h-1.445zm0 2.887h1.444v1.444h-1.445zm0 2.887h1.444V22.3h-1.445zm0 2.887h1.444v1.444h-1.445zm-3.248-8.662h1.444v1.444h-1.445zm0 2.887h1.444v1.444h-1.445zm0 2.887h1.444V22.3h-1.445zm0 2.887h1.444v1.444h-1.445zm0 2.887h1.444v3.248h-1.445z",
    transform: "translate(567.5 435.503)",
    style: {
      fill: "#080808"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 462",
    d: "M19.219 21.046a.722.722 0 0 0-.722.722v2.166h1.443v-2.166a.722.722 0 0 0-.721-.722zm0-18.046a9.147 9.147 0 0 0-5.431 1.8h10.863A9.147 9.147 0 0 0 19.219 3zM12 5.527h14.437v.722H12z",
    style: {
      fill: "#fff"
    },
    transform: "translate(570.781 442.033)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 463",
    d: "M18 30.964h3.609V28.8a1.444 1.444 0 0 1 2.887 0v2.166h3.609V14H18zm7.58-15.881h1.444v1.444H25.58zm0 2.887h1.444v1.444H25.58zm0 2.887h1.444V22.3H25.58zm0 2.887h1.444v1.444H25.58zm0 2.887h1.444v3.248H25.58zm-3.248-11.55h1.444v1.444h-1.445zm0 2.887h1.444v1.444h-1.445zm0 2.887h1.444V22.3h-1.445zm0 2.887h1.444v1.444h-1.445zm-3.248-8.662h1.444v1.444h-1.445zm0 2.887h1.444v1.444h-1.445zm0 2.887h1.444V22.3h-1.445zm0 2.887h1.444v1.444h-1.445zm0 2.887h1.444v3.248h-1.445z",
    transform: "translate(566.947 435.003)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialGraphic);
export default __webpack_public_path__ + "static/media/residential-graphic.16b3ca837ffecadb11c8f8aef40f0f91.svg";
export { ForwardRef as ReactComponent };